import React from "react";
import {UiInput} from "../input/uiInput";


type UiInputPasswordType = {
    placeholder: string,
    onChange: (event: React.FormEvent<HTMLInputElement>) => void,
    className?: string,
    isOnError?: boolean,
    onSubmit?: (event: React.FormEvent<HTMLInputElement>) => void,
}

export const UiInputPassword: React.FC<UiInputPasswordType> = (props) => {
    const [showPassword, setShowPassword] = React.useState<boolean>(true)
    const [iconPassword, setIconPassword] = React.useState<string>("eye")

    function swapIcon(icon: string) {
        return icon === "eye" ? "hidden-eye" : "eye"
    }

    return (
        <UiInput
            className={props.className}
            placeholder={props.placeholder}
            onChange={props.onChange}
            hideText={showPassword}
            icon={iconPassword}
            iconFunction={() => {
                setShowPassword(!showPassword)
                setIconPassword(swapIcon(iconPassword))
            }}
            isOnError={props.isOnError}
            onSubmit={props.onSubmit}
            name={"password"}
        />
    )
}
